$(function(){
/* scroll up */
  $(window).scroll(function () {
    let top = $(window).scrollTop();
    if (top > 300) $(".js-scrollup").addClass('is-visible');
    else $(".js-scrollup").removeClass('is-visible');
  });

  $(".js-scrollup").on("click", function () {
    $('body, html').animate({
        scrollTop: 0
      }, 1000);
  });
});

